import { useEffect, useState } from 'react';
import supabase from '../supabase/supabase';
import { ROOM_DEFAULTS, ROOMS_TABLE, ROOM_PHOTOS_TABLE } from '../data/roomDefaults';

let cache = null;

async function load() {
  const rooms = await supabase.from(ROOMS_TABLE).select('*').order('sort_order');
  const photos = await supabase.from(ROOM_PHOTOS_TABLE).select('*').order('sort_order');
  if (rooms.error || !rooms.data || !rooms.data.length) return ROOM_DEFAULTS;
  const all = photos.data || [];
  return rooms.data.map((room) => ({ ...room, photos: all.filter((photo) => photo.room_slug === room.slug) }));
}

export function featureList(room) {
  return (room.features || '').split(',').map((item) => item.trim()).filter(Boolean);
}

export function addOnList(room) {
  return (room.add_ons || '').split(/\r?\n/).map((item) => item.trim()).filter(Boolean);
}

export function useRooms() {
  const [rooms, setRooms] = useState(cache || ROOM_DEFAULTS);
  useEffect(() => {
    if (cache) return;
    load().then((data) => { cache = data; setRooms(data); }).catch(() => {});
  }, []);
  return { rooms };
}